import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Tag } from 'partner360/components/qualityIndicator'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'
import { IScoreCard } from 'partner360/features/keyInitiatives/model/types'

import styles from './ScoreCard.module.scss'

interface IScoreCardProps {
  scoreCard: IScoreCard | null
  number?: number
}

export const ScoreCard = ({ scoreCard, number }: IScoreCardProps) => {
  if (!scoreCard) {
    return <></>
  }

  return (
    <div>
      <div className={styles.scoreCard__header}>
        <RenderWhen condition={Boolean(number)}>
          <span className={styles.scoreCard__number}>{number}</span>
        </RenderWhen>

        <div className={styles.scoreCard__title}>
          <Translation text={scoreCard.titleKey} />
        </div>
      </div>

      <div className={styles.scoreCard__description}>
        <Translation text={scoreCard.descriptionKey} />
      </div>

      <div className={styles.tags}>
        <Tag
          translation={scoreCard.bandTranslationKeys?.low ?? TRANSLATION_KEYS.requirements.low}
          variant={'Low'}
        />

        <Tag
          translation={
            scoreCard.bandTranslationKeys?.moderate ?? TRANSLATION_KEYS.requirements.moderate
          }
          variant={'Moderate'}
        />

        <Tag
          translation={scoreCard.bandTranslationKeys?.high ?? TRANSLATION_KEYS.requirements.high}
          variant={'High'}
        />
      </div>
    </div>
  )
}
